import React, { useState } from "react";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import API from "@unisearch/helpers/api";
import { Grid } from "@mui/material";
import Link from "next/link";
import styles from "./form.module.scss";
import { swalError, swalMessage, swalSuccess } from "@unisearch/helpers";

export const ElearningLeadForm = () => {
  const _init = {
    fullName: "",
    contactNumber: "",
    email: "",
    cityName: "",
    status: "Active",
    terms_and_condition: false,
  };

  const [initialState, setInitialState] = useState(_init);
  const [loading, setLoading] = useState(false);
  const isFormInable = (values, errors) => {
    if (
      errors &&
      Object.keys(errors).length === 0 &&
      values.fullName &&
      values.email
    ) {
      return false;
    } else {
      return true;
    }
  };

  // form validation rules
  const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

  const validationSchema = Yup.object().shape({
    fullName: Yup.string().required("Name is required"),
    email: Yup.string()
      .email()
      .typeError("Please provide valid email")
      .required("Email is required"),
    contactNumber: Yup.string()
      .matches(phoneRegExp, "Contact Number number is not valid")
      .min(9)
      .max(15)
      .required("Contact Number is required"),
    cityName: Yup.string().required("City is required"),
    terms_and_condition: Yup.bool().oneOf(
      [true],
      "You must accept the terms and conditions"
    ),
  });

  const handleRegister = async ({ ...values }, actions) => {
    delete values.terms_and_condition;

    await API.post("public/incoming-leads", values).then((resp) => {
      if (resp.error) {
        swalError("Something went wrong");
      }
      if (!resp.error) {
        swalMessage("Welcome!", "You have successfully registered");
        actions.resetForm();
        // swalSuccess("You have successfully registered", "Welcome!");
      }
    });
  };

  return (
    <section id="form">
      <div className="container">
        <div className={styles.form_wrapper}>
          <div className={styles.form_title_wrapper}>
            <h2>Interested in free IELTS Training Program?</h2>
            <p>Just fill in your details and we’ll call you back.</p>
          </div>

          <Formik
            initialValues={initialState}
            enableReinitialize={true}
            validationSchema={validationSchema}
            onSubmit={(values, actions) => {
              handleRegister(values, actions);
            }}
          >
            {({ handleSubmit, values, setFieldValue, errors, touched }) => (
              <Form className="form" autoComplete="off">
                <Grid container columnSpacing={{ xs: 2, sm: 2, md: 4 }}>
                  <Grid item xs={12} sm={12} md={12}>
                    <div className={styles.form_group}>
                      <label>
                        Full Name <span className={styles.asterisk}>*</span>
                      </label>
                      <input
                        id="fullName"
                        name="fullName"
                        placeholder="Full Name"
                        type="text"
                        value={values.fullName ?? ""}
                        onChange={(e) => {
                          setFieldValue("fullName", e.target.value);
                          touched.fullName = true;
                        }}
                      />
                      {errors.fullName && touched.fullName ? (
                        <div className={styles.error_msg}>
                          {errors.fullName}
                        </div>
                      ) : null}
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <div className={styles.form_group}>
                      <label>
                        Email Address
                        <span className={styles.asterisk}>*</span>
                      </label>
                      <input
                        id="email"
                        name="email"
                        placeholder="Type Your Email "
                        type="email"
                        value={values.email ?? ""}
                        onChange={(e) => {
                          setFieldValue("email", e.target.value);
                          touched.email = true;
                        }}
                      />
                      {errors.email && touched.email ? (
                        <div className={styles.error_msg}>{errors.email}</div>
                      ) : null}
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={12} md={12}>
                    <div className={styles.form_group}>
                      <label>
                        Phone Number
                        <span className={styles.asterisk}>*</span>
                      </label>
                      <input
                        id="contactNumber"
                        name="contactNumber"
                        placeholder="Type Your Phone Number"
                        type="number"
                        value={values.contactNumber ?? ""}
                        onChange={(e) => {
                          setFieldValue("contactNumber", e.target.value);
                          touched.contactNumber = true;
                        }}
                      />
                      {errors.contactNumber && touched.contactNumber ? (
                        <div className={styles.error_msg}>
                          {errors.contactNumber}
                        </div>
                      ) : null}
                    </div>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12}>
                    <div className={styles.form_group}>
                      <label>
                        Your City <span className={styles.asterisk}>*</span>
                      </label>
                      <input
                        id="cityName"
                        name="cityName"
                        placeholder="Type Your City"
                        type="text"
                        value={values.cityName ?? ""}
                        onChange={(e) => {
                          setFieldValue("cityName", e.target.value);
                          touched.cityName = true;
                        }}
                      />
                      {errors.cityName && touched.cityName ? (
                        <div className={styles.error_msg}>
                          {errors.cityName}
                        </div>
                      ) : null}
                    </div>
                  </Grid>
                </Grid>

                <div className={styles.checkbox_container_wrapper}>
                  <div className={styles.checkbox_with_error_wrapper}>
                    <div className={styles.checkbox_wrapper}>
                      <label className={styles.checkbox_lebel} html="terms">
                        <Field
                          id="terms"
                          type="checkbox"
                          name="terms_and_condition"
                          className="checkbox disable-team team_values"
                          value={true}
                          checked={
                            values.terms_and_condition &&
                            values.terms_and_condition === true
                              ? true
                              : false
                          }
                          onChange={(event) => {
                            setFieldValue(
                              "terms_and_condition",
                              !values.terms_and_condition
                            );
                            touched.terms_and_condition = true;
                          }}
                        />
                        <span style={{ marginLeft: "10px" }}>
                          I agree to UniSearch
                        </span>
                      </label>
                      <Link legacyBehavior href="/terms-and-conditions">
                        <a className={styles.term_link}>Terms</a>
                      </Link>
                      <span>and</span>
                      <Link legacyBehavior href="/privacy-policy">
                        <a className={styles.term_link}>Privacy Policy.</a>
                      </Link>
                    </div>

                    {errors.terms_and_condition &&
                    touched.terms_and_condition ? (
                      <div className={styles.error_msg}>
                        {errors.terms_and_condition}
                      </div>
                    ) : null}
                  </div>
                </div>

                <button
                  type="submit"
                  className={`${
                    styles.register_btn
                  } btn btn-secondary btn-bg btn-full ${
                    loading || isFormInable(values, errors)
                      ? styles.disabled
                      : "enable"
                  } `}
                  onClick={handleSubmit}
                  disabled={
                    loading || isFormInable(values, errors) ? true : false
                  }
                >
                  Register Now!
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </section>
  );
};

export default ElearningLeadForm;
